export default __webpack_public_path__ + "static/media/robot.2065d812.svg";